export const ENCON_LOGO = require('./images/ENCON_logo.png');
export const LOGIN_BG = require('./images/Login_Background.jpg');
export const BG = require('./images/Background.jpg');
// export const UG1 = require('./images/Admin.pptx');
// export const UG2 = require('./images/Inhouse.pptx');
// export const UG3 = require('./images/AgentandCustomer.pptx');
export const GADRAWING = require('./svg/GA-6-V-D-C.svg');